import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.reducers';
import { HttpClient } from "@angular/common/http";
import { SilentLoginSuccess } from './auth/store/auth.actions';
import { SigninGeneralService } from "./shared/signinGeneral.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  checkingUser = false;
  constructor(private store: Store<AppState>, private httpClient: HttpClient,
              public generalService: SigninGeneralService, private router: Router) {}

  ngOnInit() {
    this.checkingUser = window.location.href.split('?').length > 1;
    this.httpClient.post<string[]>('aauth/get_user',{}).
      subscribe({next: (data: any) => {
        if (data['user_exist']) {
          this.generalService.signin_set_additional_parameters(window.location.href);
          this.store.dispatch(new SilentLoginSuccess(
                      {user: data.user, token: '', isAdmin: data.isAdmin, dashboards: data.dashboards }));
          return null;
        } else {
          this.checkingUser = false;
          return this.router.navigate(['']);
        }
      }}
    );
  }
}
